var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show && this.selectedDocuments
    ? _c(
        "div",
        {
          ref: "context",
          staticClass: "context-menu",
          style: _vm.style,
          attrs: { tabindex: "0" },
          on: { blur: _vm.close },
        },
        [
          _c("ul", [
            _vm.onlyOneFileSelected
              ? _c(
                  "li",
                  {
                    class: _vm.canOpenFile ? "" : "disabled-option",
                    on: {
                      click: function ($event) {
                        _vm.canOpenFile
                          ? _vm.openFile()
                          : _vm.openWarningSnackBar(_vm.messageSnackbar)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        class: _vm.canOpenFile
                          ? "has-text-dark"
                          : "disabled-option",
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-external-link-alt fa-fw",
                        }),
                        _vm._v(" Abrir en nueva pestaña\n      "),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.allFilesAreType("documento")
              ? _c(
                  "li",
                  {
                    class: _vm.canSignAll ? "" : "disabled-option",
                    on: {
                      click: function ($event) {
                        _vm.canSignAll
                          ? _vm.addAllToPila()
                          : _vm.openWarningSnackBar(_vm.messageSnackbar)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        class: _vm.canSignAll
                          ? "has-text-dark"
                          : "disabled-option",
                      },
                      [
                        _c("i", { staticClass: "fas fa-plus fa-fw" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "fas fa-inbox fa-fw" }),
                        _vm._v(" Agregar para firmar\n      "),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.allFilesAreType("documento")
              ? _c(
                  "li",
                  {
                    class: _vm.canDownloadAll ? "" : "disabled-option",
                    on: {
                      click: function ($event) {
                        _vm.canDownloadAll
                          ? _vm.downloadAll()
                          : _vm.openWarningSnackBar(_vm.messageSnackbar)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        class: _vm.canDownloadAll
                          ? "has-text-dark"
                          : "disabled-option",
                      },
                      [
                        _c("i", { staticClass: "fas fa-download fa-fw" }),
                        _vm._v(" Descargar\n      "),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "li",
              {
                class: _vm.canMoveAll ? "" : "disabled-option",
                on: {
                  click: function ($event) {
                    _vm.canMoveAll
                      ? _vm.moveAll()
                      : _vm.openWarningSnackBar(_vm.messageSnackbar)
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    class: _vm.canMoveAll ? "has-text-dark" : "disabled-option",
                  },
                  [
                    _c("i", { staticClass: "fas fa-dolly fa-fw" }),
                    _vm._v(" Mover\n      "),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.onlyOneFileSelected && !_vm.atLeastOneIsType("recibo")
              ? _c(
                  "li",
                  {
                    class: _vm.canRenameDocument ? "" : "disabled-option",
                    on: {
                      click: function ($event) {
                        _vm.canRenameDocument
                          ? _vm.renameDocument()
                          : _vm.openWarningSnackBar(_vm.messageSnackbar)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        class: _vm.canRenameDocument
                          ? "has-text-dark"
                          : "disabled-option",
                      },
                      [
                        _c("i", { staticClass: "fas fa-terminal fa-fw" }),
                        _vm._v(" Renombrar\n      "),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.onlyOneFileSelected && _vm.allFilesAreType("carpeta")
              ? _c(
                  "li",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.openPermissions()
                      },
                    },
                  },
                  [_vm._m(0)]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "li",
              {
                class: _vm.canDeleteAll
                  ? "last-option"
                  : "last-option disabled-option",
                on: {
                  click: function ($event) {
                    _vm.canDeleteAll
                      ? _vm.deleteAll()
                      : _vm.openWarningSnackBar(_vm.messageSnackbar)
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    class: _vm.canDeleteAll
                      ? "has-text-danger"
                      : "disabled-option",
                  },
                  [
                    _c("i", { staticClass: "fas fa-trash fa-fw" }),
                    _vm._v(" Eliminar\n      "),
                  ]
                ),
              ]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "has-text-dark" }, [
      _c("i", { staticClass: "fas fa-users-cog fa-fw" }),
      _vm._v(" Gestionar permisos\n      "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }